export const PUBLIC_SEARCH = "publicSearch";
export const RECENT_SEARCH = "recent_search";
export const OFFER_TYPE = "offer_type";
export const OFFER_CATEGORY = "offer_category";
export const ALL_REWARDS = 'all_rewards';
export const BRAND = "brand";
export const BRAND_CATEGORY = "brand_category";